import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
// Components
import { PageHeading } from "./Components";
import DirectoryBreadCrumb from "view/components/Breadcrumbs/DirectoryBreadCrumb";

import Button from "view/components/Button";
import usePermissions from "hooks/usePermissions";

// generate dynamic links for brands
const generateDynamicBreadcrumbLinks = (brandName: any, editMode?: boolean) => {
  switch (true) {
    case Boolean(editMode):
      return [
        { path: `/brand-details`, label: brandName },
        {
          path: `/brand-details/edit`,
          label: `Edit Brand Details`,
        },
      ];

    default:
      return [{ path: `/brand-details`, label: brandName }];
  }
};

export const Header = ({
  brandName,
  isSubmitting,
  isValid,
  handleSubmit,
  editMode,
  values,
  resetForm,
  initialValues,
}: {
  brandName: string;
  isSubmitting: any;
  isValid: any;
  handleSubmit: any;
  editMode: any;
  values: any;
  resetForm: any;
  initialValues: any;
}) => {
  const navigate = useNavigate();
  const { brands } = usePermissions();

  // brand links
  const brandLinks = generateDynamicBreadcrumbLinks(brandName, editMode);

  const handleCancel = () => {
    resetForm({ values: initialValues });
    navigate("/brand-details");
  };

  return (
    <div className="py-4">
      <div className="flex justify-between">
        <DirectoryBreadCrumb links={brandLinks} />

        {editMode ? (
          <div className="flex gap-2">
            <Button
              type="button"
              text={"Cancel"}
              filledColor="primary"
              outlinedColor="primary"
              textColor="textPrimary"
              variant="outlined"
              fontStyle="font-semibold"
              onClick={handleCancel}
            />
            <Button
              text={"Save"}
              type="submit"
              onClick={handleSubmit}
              textColor="textWhite"
              disabled={isSubmitting || !isValid}
            />
          </div>
        ) : brands.canEditBrand ? (
          <Button
            type="button"
            text={"Edit"}
            filledColor="primary"
            outlinedColor="primary"
            textColor="textPrimary"
            variant="outlined"
            fontStyle="font-semibold"
            onClick={() => navigate("/brand-details/edit")}
          />
        ) : (
          <></>
        )}
      </div>

      {!editMode && (
        <div className="py-4 flex gap-2 items-center">
          <PageHeading brandName={brandName} />
          {values.status === "archived" && (
            <p
              className={`text-[12px] font-Overpass py-1 px-2 rounded-lg capitalize max-w-max ${getStatusColor(values.status || "completed")}`}
            >
              {values.status || "completed"}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

const getStatusColor = (name: string): string => {
  switch (name) {
    case "archived":
      return "bg-primaryExtraLight text-primaryMid";
    case "public":
    case "completed":
    case "active":
      return "bg-tertiaryExtraLight text-tertiaryMid";
    case "pending":
      return "bg-tersharyMigLight text-primaryTencentLight";
    default:
      return "white";
  }
};
